import { AUTH_ATTRIBUTE } from '../../state/providers/helpers/AuthAttributeHelper';
import { UserDetails } from '../../state/providers/helpers/AppContextHelper';
export class LoggedUserDetails implements UserDetails {
  private emailId: string;
  private customerId: string;
  private customerFullName: string;

  constructor() {
    this.emailId = AUTH_ATTRIBUTE.emailId || '';
    this.customerId = AUTH_ATTRIBUTE.customerId || '';
    this.customerFullName = AUTH_ATTRIBUTE.customerName || '';
  }

  getUserModal() {
    return {
      emailId: this.emailId,
      customerId: this.customerId,
      customerFullName: this.customerFullName,
    };
  }
}
